<template>
  <nav class="navbar navbar-expand-md navbar-light bg-light mb-4 shadow">
    <a class="navbar-brand" href="/">Sub. Juventudes y Diversidades</a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link" href="/admin">Volver al admin</a>
        </li>
      </ul>
      <el-switch
        v-model="actve_chat"
        :change="do_set_active()"
        v-if="loading"
        active-text="Chat Activo"
        inactive-text="Chat desactivado"
      />
    </div>
  </nav>
</template>

<script>
import { db } from "../lib/firebase";
export default {
  data() {
    return {
      loading: false,
      actve_chat: null,
    };
  },
  created() {
    this.get_active();
  },
  // computed: {
  //   ...mapState({
  //     active: (state) => state.Chat.active,
  //   }),
  // },
  methods: {
    async get_active() {
      this.loading = false;
      this.actve_chat = (await db.doc("settings/chat").get()).data().active;
      this.loading = true;
    },
    async do_set_active(status) {
      db.doc("settings/chat").update({
        active: this.actve_chat,
      });
    },
  },
};
</script>